import {Stack} from "expo-router";
import {Platform} from "react-native";
import WebHeader from "@/lib/components/WebHeader";
import ProfileHeader from "@/lib/components/ProfileHeader";

export const unstable_settings = {
    initialRouteName: 'index',
};

export default function StackLayout() {
    return (
        <Stack
            screenOptions={{
                header: Platform.OS === "web" ? WebHeader : undefined,
                headerBackButtonDisplayMode: "minimal",
            }}
        >
            <Stack.Screen name="index" options={{title: "Profil"}}/>
            <Stack.Screen name="account/login" options={{title: "Logg inn"}}/>
            <Stack.Screen name="account/create" options={{title: "Ny bruker"}}/>
            <Stack.Screen name="account/index" options={{title: "Meg"}}/>
            <Stack.Screen name="account/activity" options={{title: "Aktivitetslogg"}}/>
            <Stack.Screen name="account/edit" options={{title: "Tilpass profil"}}/>
            <Stack.Screen name="account/picture" options={{title: "Profilbilde"}}/>
            <Stack.Screen name="account/settings" options={{title: "Innstillinger"}}/>
            <Stack.Screen name="account/verifyemail" options={{title: "Bekreft e-postadresse"}}/>
            <Stack.Screen name="account/resetpassword" options={{title: "Nytt passord"}}/>
            <Stack.Screen name="profile/[username]/index" options={{title: "Brukerprofil", headerRight: ProfileHeader}}/>
            <Stack.Screen name="profile/[username]/share" options={{title: "Del"}}/>
            <Stack.Screen name="profile/[username]/friends" options={{title: "Venner"}}/>
            <Stack.Screen name="profile/[username]/followers" options={{title: "Følgere"}}/>
            <Stack.Screen name="profile/[username]/common" options={{title: "Felles venner"}}/>
            <Stack.Screen name="profile/[username]/network" options={{title: "Omgangskrets"}}/>
            <Stack.Screen name="docs/index" options={{title: "Hjelp og veiledning"}}/>
            <Stack.Screen name="docs/[slug]" options={{title: ""}}/>
            <Stack.Screen name="version" options={{title: "Versjon"}}/>
        </Stack>
    );
}